module.exports = "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJlcnJvci5zdmc/MTllZTZiN2U2NjQyZDc1ZDYxNDRiMGM4MjA5YzkzZDYiOw=="


//////////////////
// WEBPACK FOOTER
// ./node_modules/blueimp-gallery/img/error.svg
// module id = 526
// module chunks = 2